<template>
  <div class="content has-text-centered">
    <div class="columns is-vcentered">
      <div class="column is-6 is-offset-3">
        <div
          style="height: 700px;"
          class="box"
        >
          <div
            v-show="error"
            style="color:red; word-wrap:break-word;"
          >
            {{ error }}
          </div>
          <div v-show="this.$route.hash.length > 5">
            Logging in
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'

export default {
  data () {
    return {
      data: {
        body: {
          username: null,
          password: null
        },
        rememberMe: false
      },
      error: null
    }
  },
  created () {
    if (this.$route.hash.length > 5) {
      console.log('logging in')
    }
  },
  methods: {
    ...mapMutations([
      'RESET_RAPPORTAGE_STATE',
      'RESET_INVENTARISATIE_STATE',
      'RESET_MANAGEMENT_STATE',
      'RESET_PROJECTMANAGEMENT_STATE',
      'RESET_VASTGOED_STATE'
    ]),
    oauth () {
      this.$auth.oauth2({
        provider: 'kiwa'
      })
      this.RESET_RAPPORTAGE_STATE()
      this.RESET_INVENTARISATIE_STATE()
      this.RESET_MANAGEMENT_STATE()
      this.RESET_PROJECTMANAGEMENT_STATE()
      this.RESET_VASTGOED_STATE()
    }
  }
  // filters: {
  //   json: function (value) {
  //     console.log(value)
  //     return value
  //   }
  // }

}
</script>

<style lang="scss" scoped>
.is-title {
    text-transform: capitalize;
}
</style>
